function ContentPlanning(props) {


    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">편성</h4>
                <h5 className="recruit_titleline_title">콘텐츠전략</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                콘텐츠전략 직무는, SBS 채널이 콘텐츠를 통해 달성하고자 하는 가치와 지향점을 설정하는 데에서 출발해 개별 콘텐츠의 경쟁력 검토, <br />
                최적화된 SBS의 콘텐츠 포트폴리오 설계, 콘텐츠 투자관리 및 수익성 제고방안 수립 등, 콘텐츠와 관련된 종합의사결정을 총괄하는 <br />
                직무입니다. <br /><br />

                1. 연간 전략 수립으로 장기적인 비전을 제시하는 데에서 출발하여, <br />
                2. 기획단계에서는 콘텐츠의 잠재가치와 발전 가능성을 판단하여 제작 여부를 결정하고, <br />
                3. 제작부문과 긴밀한 협의를 통해 콘텐츠의 가치를 극대화할 수 있는 형식, 분량, 시기, 제작구조를 결정합니다. 필요한 경우 외부 콘텐츠 플랫폼사, 제작사와 공동투자 및 공동제작의 구조 등도 함께 논의합니다.<br />
                4. 방송된 콘텐츠의 시청데이터, 수익성데이터를 다각도로 분석하는 등 콘텐츠전략을 체계적으로 수행, 발전시켜 <br />
                5. 장기적으로 SBS의 콘텐츠 가치를 밸류업 시키는 것을 목적으로 합니다. <br /><br />

                따라서 콘텐츠에 대한 충만한 관심과 애정을 기본으로 하되 객관적으로 가치평가를 실시할 수 있는 분석적 사고가 필수적입니다. <br />
                또한, 일반적인 산업분야와 달리 정성적인 평가가 많이 들어갈 수 밖에 없는 콘텐츠와 미디어 산업을 균형있게 바라보는 통찰력, 그리고 콘텐츠 전략을 실행하는 과정에서의 창의성이나 자기 주도성이 있으면 금상첨화입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                콘텐츠전략팀에는 콘텐츠가 주는 즐거움에 흠뻑 빠진 사람들이 함께 일하고 있습니다. <br />
                기술의 발달, 소비 트렌드의 변화와 함께 미디어 환경이 빠르게 변화하고 있지만, 그 속에서도 절대 변하지 않는 것이 하나 있습니다. <br />
                바로 콘텐츠의 가치입니다. 콘텐츠전략팀은 콘텐츠가 지닌 가치를 널리 전파하고 콘텐츠의 힘을 극대화할 수 있도록 다방면에서 콘텐츠 관련 전략을 수립하는 부서입니다. 이를 위해 최적의 채널 편성전략으로 SBS의 영향력을 강화하고, 나아가 시청자들의 시청 패턴과 트렌드를 리드합니다.

                </p>
                <em className="recruit_bold_text">개편</em>
                <p className="recruit_subinfo_text">
                    SBS콘텐츠라인업을 결정하는 일체의 업무입니다.<br />
                    각 콘텐츠의 경쟁력과 시청자의 시청 패턴을 고려하여 신규 프로그램 편성, 기존 프로그램 폐지, 시간대 이동 편성, 편성 패턴 변경 등을<br />
                    전략적으로 기획하고 실행합니다.
                </p>
                <em className="recruit_bold_text">드라마라인업</em>
                <p className="recruit_subinfo_text">
                    드라마 작품을 시놉시스와 대본 단계에서 검토하고 채널 라인업 여부, 적정 편성슬롯을 결정합니다.
                </p>
                <em className="recruit_bold_text">구매 / 제작관리</em>
                <p className="recruit_subinfo_text">
                    제작구조 적정성을 검토하고 조정하며, 콘텐츠 구매업무를 총괄합니다.<br />
                    변화하는 콘텐츠 업계에 맞추어, 외부 콘텐츠 및 플랫폼 사업자와의 협업 구조를 설계합니다.<br />
                    주어진 예산 하, 최적의 콘텐츠 포트폴리오를 구축할 수 있는 콘텐츠 수급 방안을 수립합니다.<br />
                    기획단계에서 콘텐츠별 유효 제작비를 산정하고 콘텐츠 제작구조를 유관부서와 긴밀히 협의합니다.<br />
                </p>
                <em className="recruit_bold_text">데이터분석, KPI 수립</em>
                <p className="recruit_subinfo_text">
                    TV 시청데이터와 디지털, OTT 데이터를 다각도로 분석합니다.<br />
                    데이터에 기반을 두고 콘텐츠 경쟁력을 면밀히 분석하고 이를 향후 콘텐츠 전략 및 편성전략 수립에 활용합니다.<br />
                    데이터 분석 및 예측을 통해 콘텐츠와 관련된 전사적인 KPI 목표를 설정하고 성과를 점검합니다.
                </p>
                <em className="recruit_bold_text">시청지표 연구, 트렌드 리서치</em>
                <p className="recruit_subinfo_text">
                    장기 플랜으로 콘텐츠의 가치를 잘 측정할 수 있는 적정한 지표를 연구합니다. <br />
                    트렌드 리서치를 통해 콘텐츠 기획의 방향성을 제시하고 소통합니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    미디어/콘텐츠 산업에서 결국 핵심은 콘텐츠입니다.<br />
                    콘텐츠기획팀은 콘텐츠전략을 수립하는 핵심 부서로 콘텐츠와 관련된 주요 의사결정과정에서 중추적인 역할을 담당합니다. 이를 통해<br />
                    콘텐츠와 플랫폼 산업의 트렌드를 정확히 파악하고, 미래를 예측하는 안목을 키울 수 있습니다.<br /><br />
                    예능/교양/드라마/보도뿐 아니라 마케팅, 광고, 유통, 미디어 전략 등 회사 내 다양한 조직과 소통하고<br />
                    협의하는 만큼, 업무를 통해 축적된 경험과 네트워크는 특정 분야에 국한되지 않고 폭넓게 활용될 수 있습니다.<br />
                    향후 콘텐츠/플랫폼 관련 분야의 리더 역할을 수행하는 데 필요한 핵심적인 역량을 쌓을 수 있습니다.

                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    안녕하세요. SBS 콘텐츠전략본부 콘텐츠기획팀에서 개편과 드라마 라인업 업무를 담당하고 있는 조혜빈입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    제작진이 심혈을 기울여 제작한 예능/드라마/교양/보도 프로그램이 SBS 채널에서 빛을 발할 수 있도록 최적의 편성전략을 세워 개편을<br />
                    단행하고, 온에어된 콘텐츠가 SBS를 대표하는 킬러콘텐츠로 자리매김 했을 때 성취감을 크게 느낍니다. 기획단계에서 콘텐츠의 잠재력과<br />
                    가치를 정확히 예측하여 의사결정을 하고, 제작형식과 제작구조, 편성시기, 운행전략 등 여러 방면에서 최적화된 콘텐츠 전략을 수립하여<br />
                    이것이 결과적으로 좋은 성과로 이어졌을 때의 보람은 이루 말할 수 없습니다.<br /><br />
                    특히 SBS의 조직문화는 젊고, 서로 존중합니다. 연차에 상관없이 서로의 전문영역을 인정해주고, 서로 활발하게 소통하며 이를 통해<br />
                    합리적으로 빠르게 의사 결정을 합니다. 콘텐츠 전략의 핵심인 콘텐츠전략팀원으로서 만족감과 뿌듯함을 느낍니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    SBS 구성원들은 누구나 업계 최고 역량의 동료와 함께 일한다고 자부하고 있습니다. <br />
                    특히 콘텐츠기획팀은 업무의 특성상 요즘 트렌드와 대중의 흐름을 주시하고 있어야 하므로, 선배와 후배 모두 서로의 이야기를 항상 경청하고, 가감 없이 의견을 교환하며 함께 성장합니다.<br /><br />
                    콘텐츠기획팀의 매력 중 하나는 바로 덕업일치가 가능하다는 점이 아닐까 싶습니다. 다양한 콘텐츠를 항상 즐기고, 이에 대해 자유롭게 동료와 소통합니다.
                    이러한 과정이 콘텐츠를 향한 정확한 안목을 키우는 데 큰 도움이 되기 때문인데요, 그래서 평소 콘텐츠를 즐겨 보신다면 더욱<br />
                    즐겁게 일하실 수 있을 것입니다.<br /><br />
                    물론 당연히 콘텐츠를 향한 덕질로만 끝나는 것이 아니라, 콘텐츠를 향한 비판적 사고로 관점이 확장되어야 하겠지요? 이처럼 콘텐츠기획팀의 주요 업무들을 수행하다 보면,
                    미디어/콘텐츠 업계에서 미래 성장동력의 핵심 역량을 갖춘 콘텐츠 전문가로 성장할 수 있을 것입니다.
                </p>
            </div>
        </div>);

    // return (
    //     <div className="recruit_contents">
    //         <div className="recruit_titleline_w">
    //             <h4 className="recruit_titleline_info">콘텐츠전략</h4>
    //             <h5 className="recruit_titleline_title">콘텐츠기획</h5>
    //         </div>
    //         <div className="recruit_subtitleline_w">
    //             <h6 className="recruit_titleline_info">직무소개</h6>
    //         </div>
    //         <div className="recruit_cont">
    //             <h7 className="recruit_subtitle">직무 및 필요역량</h7>
    //             <p className="recruit_subinfo_text">
    //                 콘텐츠기획팀은 SBS 콘텐츠 전략의 헤드쿼터입니다. SBS 채널이 콘텐츠를 통해 달성하고자 하는 가치와 지향점을 설정하는 데에서 출발해<br />
    //                 채널에서 방송되는 모든 콘텐츠의 라이프사이클을 함께합니다.<br /><br />
    //                 우선 연간 전략 수립으로 장기적인 비전을 제시하는 데에서 출발하여 기획단계에서부터 콘텐츠의 가치를 판단하여 제작 여부를 결정하고,<br />
    //                 제작부문과 긴밀한 협의를 통해 콘텐츠의 가치를 극대화할 수 있는 형식, 편성시기, 시간대, 제작구조를 결정합니다. 또한, 방송된 콘텐츠의<br />
    //                 데이터를 다각도로 분석하여 향후 콘텐츠/편성 전략 수립 시 적용하고, 연간 콘텐츠 라인업과 콘텐츠 포트폴리오를 수립 및 관리하고 있습니다.<br />
    //                 최근에는 콘텐츠 소비가 디지털 영역에서도 활발히 이루어지면서 콘텐츠기획팀의 업무영역 또한 확장되고 있습니다.<br /><br />
    //                 따라서 콘텐츠에 대한 충만한 관심과 애정, 비판적 사고와 더불어 각종 협상을 원활히 할 수 있는 커뮤니케이션 능력,
    //                 팀워크를 중시하는<br />사회성이 있으면 좋습니다. 또한, 콘텐츠를 많이 접하기 때문에 각종 이슈에 대한 균형감 있는 시각과
    //                 객관적으로 데이터를 분석할 수 있는<br />능력, 그리고 콘텐츠 전략을 기획하는 과정에서의 창의성이나 자기 주도성이 있으면
    //                 금상첨화입니다.
    //             </p>
    //         </div>
    //         <div className="recruit_cont">
    //             <h7 className="recruit_subtitle">부서 소개</h7>
    //             <p className="recruit_subinfo_text">
    //                 콘텐츠전략본부 콘텐츠기획팀에는 콘텐츠가 주는 즐거움에 흠뻑 빠진 사람들이 함께 일하고 있습니다.<br />
    //                 기술의 발달, 소비 트렌드의 변화와 함께 미디어 환경이 빠르게 변화하고 있지만, 그 속에서도 절대 변하지 않는 것이 하나 있습니다. 바로<br />
    //                 콘텐츠의 가치입니다. 콘텐츠기획팀은 콘텐츠가 지닌 가치를 널리 전파하고 콘텐츠의 힘을 극대화할 수 있도록 다방면에서 콘텐츠 관련 전략을<br />
    //                 수립하는 부서입니다. 이를 위해 최적의 채널 편성전략으로 SBS의 영향력을 강화하고, 나아가 시청자들의 시청 패턴과 트렌드를 리드합니다.
    //             </p>
    //             <em className="recruit_bold_text">개편</em>
    //             <p className="recruit_subinfo_text">
    //                 SBS콘텐츠라인업을 결정하는 일체의 업무입니다.<br />
    //                 각 콘텐츠의 경쟁력과 시청자의 시청 패턴을 고려하여 신규 프로그램 편성, 기존 프로그램 폐지, 시간대 이동 편성, 편성 패턴 변경 등을<br />
    //                 전략적으로 기획하고 실행합니다.
    //             </p>
    //             <em className="recruit_bold_text">드라마라인업/구매</em>
    //             <p className="recruit_subinfo_text">
    //                 드라마 작품을 시놉시스와 대본 단계에서 검토하고 채널 라인업 여부, 적정 편성슬롯을 결정합니다.<br />
    //                 제작구조 적정성을 검토하고 조정하며, 드라마 구매업무를 총괄합니다.
    //             </p>
    //             <em className="recruit_bold_text">제작관리</em>
    //             <p className="recruit_subinfo_text">
    //                 기획단계에서 콘텐츠별 제작비 적정선을 핸들링하고 콘텐츠 제작구조를 유관부서와 긴밀히 협의합니다.
    //             </p>
    //             <em className="recruit_bold_text">데이터분석, KPI 수립</em>
    //             <p className="recruit_subinfo_text">
    //                 TV 시청데이터와 디지털, OTT 데이터를 다각도로 분석합니다.<br />
    //                 데이터에 기반을 두고 콘텐츠 경쟁력을 면밀히 분석하고 이를 향후 콘텐츠 전략 및 편성전략 수립에 활용합니다.<br />
    //                 데이터 분석 및 예측을 통해 콘텐츠와 관련된 전사적인 KPI 목표를 설정하고 성과를 점검합니다.
    //             </p>
    //             <em className="recruit_bold_text">시청지표 연구, 트렌드 리서치</em>
    //             <p className="recruit_subinfo_text">
    //                 장기 플랜으로 콘텐츠의 가치를 잘 측정할 수 있는 적정한 지표를 연구합니다. <br />
    //                 트렌드 리서치를 통해 콘텐츠 기획의 방향성을 제시하고 소통합니다.
    //             </p>
    //         </div>
    //         <div className="recruit_cont">
    //             <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
    //             <p className="recruit_subinfo_text">
    //                 미디어/콘텐츠 산업에서 결국 핵심은 콘텐츠입니다.<br />
    //                 콘텐츠기획팀은 콘텐츠전략을 수립하는 핵심 부서로 콘텐츠와 관련된 주요 의사결정과정에서 중추적인 역할을 담당합니다. 이를 통해<br />
    //                 콘텐츠와 플랫폼 산업의 트렌드를 정확히 파악하고, 미래를 예측하는 안목을 키울 수 있습니다.<br /><br />
    //                 예능/교양/드라마(스튜디오S)/보도뿐 아니라 마케팅, 광고, 유통, 미디어 전략 등 회사 내 다양한 조직과 소통하고 협의하는 만큼,
    //                 업무를 통해 축적된 경험과 네트워크는 특정 분야에 국한되지 않고 폭넓게 활용될 수 있습니다.
    //                 향후 콘텐츠/플랫폼 관련 분야의 리더 역할을 수행하는 데 필요한 핵심적인 역량을 쌓을 수 있습니다.<br /><br />
    //                 콘텐츠 제작 경험이 업무수행에 도움이 되기 때문에 본인 희망 시 예능, 교양 등 제작부서에서 근무하는 기회가 닿을 수도 있고, 향후 드라마<br />
    //                 스튜디오, 디지털 스튜디오, 미디어 전략, 미디어 사업, 마케팅 솔루션, 콘텐츠 프로모션 등 다양한 부서에서 편성, 마케팅과 유통을 아우르는<br />
    //                 다양한 커리어 포트폴리오를 쌓아나갈 수 있습니다.
    //             </p>
    //         </div>
    //         <div className="recruit_subtitleline_w">
    //             <h6 className="recruit_titleline_info">선배인터뷰</h6>
    //         </div>
    //         <div className="recruit_cont">
    //             <h7 className="recruit_subtitle">본인 소개</h7>
    //             <p className="recruit_subinfo_text">
    //                 안녕하세요. SBS 콘텐츠전략본부 콘텐츠기획팀에서 개편과 드라마 라인업 업무를 담당하고 있는 조혜빈입니다.
    //             </p>
    //         </div>
    //         <div className="recruit_cont">
    //             <h7 className="recruit_subtitle">콘텐츠기획팀에서 일하게 된 계기는?</h7>
    //             <p className="recruit_subinfo_text">
    //                 예능PD로 SBS에 입사했습니다. 예능 프로그램을 제작하며 시청자와 소통하는 일은 정말 재미있고 보람찬 경험이었습니다. <br />
    //                 다만 예능PD로서 콘텐츠기획팀/편성팀과 활발히 커뮤니케이션할 일이 많았는데, 이 과정에서 차츰 미디어/콘텐츠 분야의 헤드쿼터인<br />
    //                 콘텐츠전략과 편성전략을 수립하고 실행하는 업무가 매력 있게 다가왔고, 그 일을 해보고 싶다는 마음이 커졌습니다. 감사하게도 회사에서<br />이러한
    //                 저의 열의를 인정해줘서 편성팀의 편성PD로 전직하여 일할 수 있게 되었고, 이후 콘텐츠기획팀에서 일하게 되었습니다.<br /><br />
    //                 이처럼 콘텐츠기획팀에는 예능, 교양, 편성, 콘텐츠 프로모션, 방송경영 등 다양한 직무 경로를 통해 온 사람들이 함께 하며 시너지 효과를 내고 있습니다.
    //                 다양한 분야에서 폭넓은 네트워크를 쌓을 수 있고, 동료와 함께 업무를 수행하며 콘텐츠와 플랫폼 전반에 대해 정확히 파악하고<br />
    //                 미래를 예측하는 안목을 키울 수 있어 보람있게 생각하고 있습니다.
    //             </p>
    //         </div>
    //         <div className="recruit_cont">
    //             <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
    //             <p className="recruit_subinfo_text">
    //                 제작진이 심혈을 기울여 제작한 예능/드라마/교양/보도 프로그램이 SBS 채널에서 빛을 발할 수 있도록 최적의 편성전략을 세워 개편을<br />
    //                 단행하고, 온에어된 콘텐츠가 SBS를 대표하는 킬러콘텐츠로 자리매김 했을 때 성취감을 크게 느낍니다. 기획단계에서 콘텐츠의 잠재력과<br />
    //                 가치를 정확히 예측하여 의사결정을 하고, 제작형식과 제작구조, 편성시기, 운행전략 등 여러 방면에서 최적화된 콘텐츠 전략을 수립하여<br />
    //                 이것이 결과적으로 좋은 성과로 이어졌을 때의 보람은 이루 말할 수 없습니다.<br /><br />
    //                 특히 SBS의 조직문화는 젊고, 서로 존중합니다. 연차에 상관없이 서로의 전문영역을 인정해주고, 서로 활발하게 소통하며 이를 통해<br />
    //                 합리적으로 빠르게 의사 결정을 합니다. 콘텐츠 전략의 핵심인 콘텐츠기획팀원으로서 만족감과 뿌듯함을 느낍니다.
    //             </p>
    //         </div>
    //         <div className="recruit_cont">
    //             <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
    //             <p className="recruit_subinfo_text">
    //                 SBS 구성원들은 누구나 업계 최고 역량의 동료와 함께 일한다고 자부하고 있습니다. <br />
    //                 특히 콘텐츠기획팀은 업무의 특성상 요즘 트렌드와 대중의 흐름을 주시하고 있어야 하므로, 선배와 후배 모두 서로의 이야기를 항상 경청하고, 가감 없이 의견을 교환하며 함께 성장합니다.<br /><br />
    //                 콘텐츠기획팀의 매력 중 하나는 바로 덕업일치가 가능하다는 점이 아닐까 싶습니다. 다양한 콘텐츠를 항상 즐기고, 이에 대해 자유롭게 동료와 소통합니다.
    //                 이러한 과정이 콘텐츠를 향한 정확한 안목을 키우는 데 큰 도움이 되기 때문인데요, 그래서 평소 콘텐츠를 즐겨 보신다면 더욱<br />
    //                 즐겁게 일하실 수 있을 것입니다.<br /><br />
    //                 물론 당연히 콘텐츠를 향한 덕질로만 끝나는 것이 아니라, 콘텐츠를 향한 비판적 사고로 관점이 확장되어야 하겠지요? 이처럼 콘텐츠기획팀의 주요 업무들을 수행하다 보면,
    //                 미디어/콘텐츠 업계에서 미래 성장동력의 핵심 역량을 갖춘 콘텐츠 전문가로 성장할 수 있을 것입니다.
    //             </p>
    //         </div>
    //     </div>);
}

export default ContentPlanning;

